import Component from "../../component";
import {resolvePath} from "../../helpers/object";

export const ProductItemImageConfig = {
    signature: 'productItemImage',
    baseHtmlClass: 'product_thumbnail__image',
    selector: '.product_thumbnail__image',
    initedHtmlClassModifier: 'inited',
    hasImageHtmlClassModifier: 'has_image',
    productItemImageConfigDataKey: 'productItemImageConfigData'
};

export class ProductItemImage extends Component {

    constructor(id_or_element, props = {}) {
        super({
            element: id_or_element,
            config: ProductItemImageConfig
        });

        const configData = this.element[ProductItemImageConfig.productItemImageConfigDataKey] || {};
        this.styleRules = resolvePath(configData, 'collection_image_data.styles') || {};

        this.imgElement = this.element.querySelector('img');

        this.imgSrc = null;

        if (this.imgElement) {
            this.imgSrc = this.imgElement.getAttribute('src');

            const mutationConfig = {attributes: true, childList: false, subtree: false};
            new MutationObserver(this.handleMutation.bind(this)).observe(this.imgElement, mutationConfig);
        }

        this.inited = true;
        this.render();
    }

    handleMutation(mutations, observer) {
        if (isSrcAttributeMutated(mutations)) {
            this.imgSrc = this.imgElement.getAttribute('src');
            this.render();
        }
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, ProductItemImageConfig.initedHtmlClassModifier);
        this.renderElementStyle();
        this.conditionallySetHtmlClassState(!!this.imgSrc, ProductItemImageConfig.hasImageHtmlClassModifier);
    }


    renderElementStyle() {
        for (const styleRule in this.styleRules) {
            this.element.style[styleRule] = this.styleRules[styleRule];
        }

        if (!!this.imgSrc) {
            this.element.style['backgroundImage'] = `url(${this.imgSrc})`;
        }
    }
}

function isSrcAttributeMutated(mutations) {
    return mutations.some((mutation) => mutation['attributeName'] === 'src');
}

